var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketDiscountDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8747 11.4584C17.8747 10.1934 18.9013 9.16675 20.1663 9.16675V8.25008C20.1663 4.58341 19.2497 3.66675 15.583 3.66675H6.41634C2.74967 3.66675 1.83301 4.58341 1.83301 8.25008V8.70841C3.09801 8.70841 4.12467 9.73508 4.12467 11.0001C4.12467 12.2651 3.09801 13.2917 1.83301 13.2917V13.7501C1.83301 17.4167 2.74967 18.3334 6.41634 18.3334H15.583C19.2497 18.3334 20.1663 17.4167 20.1663 13.7501C18.9013 13.7501 17.8747 12.7234 17.8747 11.4584Z",
    stroke: "#D5D5D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.5208L13.75 8.02075",
    stroke: "#D5D5D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7453 13.5208H13.7535",
    stroke: "#D5D5D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24529 8.47909H8.25352",
    stroke: "#D5D5D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDiscountDark);
export default __webpack_public_path__ + "static/media/ticket-discount-dark.a85b5d3ed056a3fbbd3c21ef27ddd869.svg";
export { ForwardRef as ReactComponent };